module.exports = __webpack_public_path__ + "6ff69bdc02015bfc1eed18e8e5e8cc90.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/rockers-hat.png
 ** module id = 469
 ** module chunks = 0
 **/